/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Leader_PlaceholderInputs */

const cs_settings_teams_leader_placeholder = /** @type {(inputs: Settings_Teams_Leader_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat vedoucího…`)
};

const en_settings_teams_leader_placeholder = /** @type {(inputs: Settings_Teams_Leader_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search a leader…`)
};

/**
* | output |
* | --- |
* | "Search a leader…" |
*
* @param {Settings_Teams_Leader_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_leader_placeholder = /** @type {((inputs?: Settings_Teams_Leader_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Leader_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_leader_placeholder(inputs)
	return cs_settings_teams_leader_placeholder(inputs)
});